import { useTranslation } from "next-i18next";
import ErrorBoundary from "../ErrorBoundary/ErrorBoundary.web";

/**
 * Fallback error page should the entire app crash.
 *
 * Supports translations.
 */
function ErrorAppCrashInternal() {
  const { t } = useTranslation("common");

  return (
    <div
      style={{
        position: "absolute",
        top: "50%",
        fontFamily: "Lato, sans-serif",
        display: "flex",
        justifyContent: "center",
        transform: "translateY(-50%)",
        left: "16px",
        right: "16px",
        textAlign: "center",
      }}
    >
      <p>
        {t(
          `Oops! Something went wrong. We're working to fix this issue. Please try refreshing the page or come back later.`
        )}
      </p>
    </div>
  );
}

/**
 * Fallback error component for ErrorAppCrash should the fallback error page crash
 *
 * Does *not* support translations.
 */
ErrorAppCrash.Error = function ErrorAppCrashError() {
  return (
    <div
      style={{
        position: "absolute",
        top: "50%",
        fontFamily: "Lato, sans-serif",
        display: "flex",
        justifyContent: "center",
        transform: "translateY(-50%)",
        left: "16px",
        right: "16px",
        textAlign: "center",
      }}
    >
      <p>
        Oops! Something went wrong. We&apos;re working to fix this issue. Please
        try refreshing the page or come back later.
      </p>
    </div>
  );
};

// See ErrorAppCrashInternal
function ErrorAppCrash() {
  return (
    <ErrorBoundary fallback={<ErrorAppCrash.Error />}>
      <ErrorAppCrashInternal />
    </ErrorBoundary>
  );
}

export default ErrorAppCrash;
